import React, { FC, useEffect } from "react";
import { Redirect } from "react-router";

// configs
import { PATH_NAME } from "configs";

// services
import authService from "services/authService";
import { Props } from "models/IRoutes";
import { useSelector } from "react-redux";
import { userSelector } from "selectors/auth.selector";

interface Crumbs {
  label: string;
  path: string;
}

const AuthGuard: FC<Props> = ({ children }) => {
  const isAuth = authService.getAccessToken();

  if (!isAuth) return <Redirect to={PATH_NAME.LOGIN} />;

  return <>{children}</>;
};

export default AuthGuard;
